import React from "react";
import { ChevronDown, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Badge } from "../ui/badge";
import { cn } from "../../lib/utils/utils";

const MultiSelect = ({ 
  options = [], 
  value = [], 
  onChange, 
  placeholder = "Select options...",
  className 
}) => {
  // Ensure value is always an array
  const selectedValues = Array.isArray(value) ? value : [];

  const handleSelect = (optionValue) => {
    const isSelected = selectedValues.some(v => String(v) === String(optionValue));
    let newValue;
    if (isSelected) {
      newValue = selectedValues.filter((v) => String(v) !== String(optionValue));
    } else {
      newValue = [...selectedValues, optionValue];
    }
    onChange(newValue);
  };

  const getLabel = (optionValue) => {
    const option = options.find((o) => String(o.id) === String(optionValue));
    return option ? option.name : optionValue;
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div
          className={cn(
            "flex min-h-10 w-full items-center justify-between rounded-md border border-slate-200 bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer",
            className
          )}
        >
          <div className="flex flex-wrap gap-1">
            {selectedValues.length > 0 ? (
              selectedValues.map((val) => (
                <Badge 
                  key={val} 
                  variant="secondary" 
                  className="rounded-sm font-normal bg-slate-100 text-slate-900 hover:bg-slate-100"
                >
                  {getLabel(val)}
                </Badge>
              ))
            ) : (
              <span className="text-slate-500">{placeholder}</span>
            )}
          </div>
          <ChevronDown className="h-4 w-4 opacity-50 shrink-0" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-[var(--radix-dropdown-menu-trigger-width)] max-h-60 overflow-y-auto">
        {options.length > 0 ? (
          options.map((option) => (
            <DropdownMenuCheckboxItem
              key={option.id}
              checked={selectedValues.some(v => String(v) === String(option.id))}
              onCheckedChange={() => handleSelect(option.id)}
              onSelect={(e) => e.preventDefault()} // Keep open on select
            >
              {option.name}
            </DropdownMenuCheckboxItem>
          ))
        ) : (
          <div className="py-2 px-4 text-sm text-slate-500">No options found</div>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default MultiSelect;
